import { createFileRoute } from '@tanstack/react-router';
import { AgentForm } from '../../../features/agents/components/AgentForm';
import { usePageTitle } from '../../../lib/hooks';
import { PageHeader } from '../../../components/layout/PageHeader';

export const Route = createFileRoute('/_auth/agents/new')({
  component: NewAgentRoute,
});

function NewAgentRoute() {
  usePageTitle('New Agent');
  return (
    <div className="flex flex-col gap-6 max-w-[840px]">
      <PageHeader title="Create Agent" subtitle="Fill out the details below to provision a new agent." backTo="/agents" />
      
      <div className="bg-surface-1 border border-border rounded-lg p-6">
        <AgentForm />
      </div>
    </div>
  );
}
